import { getJson } from "./getJson";

export async function getBonusQFileAppeal() {
  return getJson(`/internal-api/employee/statistics/quarter/appeal/file`);
}

export async function postBonusQFileAppeal(fileId: number) {
  const response = await fetch(
    `/internal-api/employee/statistics/quarter/appeal/file`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ fileId }),
    },
  );

  if (!response.ok) throw new Error(`POST error: ${response.status}`);
  return response.json();
}

export async function putBonusQFileAppeal(fileId: number) {
  const response = await fetch(
    `/internal-api/employee/statistics/quarter/appeal/file`,
    {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      credentials: "include",
      body: JSON.stringify({ fileId }),
    },
  );

  if (!response.ok) throw new Error(`PUT error: ${response.status}`);
  return response.json();
}

export async function deleteBonusQFileAppeal() {
  const response = await fetch(
    `/internal-api/employee/statistics/quarter/appeal/file`,
    {
      method: "DELETE",
      headers: {
        Accept: "application/json",
      },
      credentials: "include",
    },
  );

  if (!response.ok) throw new Error(`DELETE error: ${response.status}`);
  return response.json();
}
